import { createSlice } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const config = createSlice({
  name: 'config',
  initialState: {
    config: {},
    reloadAttemptedForVersion: null
  },
  reducers: {
    setConfig (state, action) {
      state.config = action.payload
    },
    setReloadAttemptedVersion (state, action) {
      state.reloadAttemptedForVersion = action.payload
    }
  }
})

const persistConfig = { key: 'config', storage }

export const { setConfig, setReloadAttemptedVersion } = config.actions
export const ConfigReducer = persistReducer(persistConfig, config.reducer)
